import React from 'react';
import { Box } from '@acko-tech/building-blocks.ui.common';
import { ISelectedAddon } from '../../useFormData/types';
import { formatAddonDisplayName, formatAddonRupee } from './format';
import {
    SelectedAddonLine,
    SelectedAddonMeta,
    SelectedAddonName,
    SelectedAddonsWrap,
} from './styles';

type Props = {
    selectedAddons: ISelectedAddon[];
};

export function SelectedAddonsSummary({
    selectedAddons,
}: Props): JSX.Element | null {
    if (!selectedAddons?.length) return null;

    return (
        <SelectedAddonsWrap>
            {selectedAddons.map((addon) => (
                <SelectedAddonLine key={addon.id}>
                    <Box>
                        <SelectedAddonName>
                            {formatAddonDisplayName(addon.name)}
                        </SelectedAddonName>
                        <SelectedAddonMeta>
                            {formatAddonRupee(addon.price)}
                        </SelectedAddonMeta>
                    </Box>
                </SelectedAddonLine>
            ))}
        </SelectedAddonsWrap>
    );
}
